import {EpLayer} from "./layer";
import {
    farInventoryLocationHunterPointStyle,
    farInventoryLocationPointStyle, inventoryLocationHunterPointStyle, inventoryLocationPointStyle,
} from "../styles/inventory-locations";
import {devicesStyle, farDevicesStyle} from "../styles/devices";
import {Feature} from "ol";
import {Point} from "ol/geom";
import {fromLonLat} from "ol/proj";
import {farHuntersPointsStyle, huntersPointsStyle} from "../styles/hunters-points";

// export class HunterPoints extends EpLayer {
//     constructor(map) {
//         super(map);
//
//         this.style = inventoryLocationHunterPointStyle;
//         this.farStyle = farInventoryLocationHunterPointStyle;
//
//         this.title = 'Myśliwi (urządzenia)';
//         this.name = 'hunters';
//
//         return this;
//     }
//
// }

export class HunterPointsLayer extends EpLayer {
    constructor(map) {
        super(map);
        this.style = huntersPointsStyle;
        this.farStyle = farHuntersPointsStyle;
        this.title = 'Stanowiska myśliwych';
        this.name = 'hunters';

        return this;
    }

    // addToMapFromCoordinates(coordinates, options = {}) {
    //     options = {...{resize: false}, ...options};
    //
    //     let feature = new Feature({
    //         geometry: new Point(fromLonLat(coordinates.split(","))),
    //         zoomLimit: 13.5,
    //         name: options.name,
    //         type: 'hunter',
    //        // device_type_id: options.device_type_id,
    //         changed: false
    //     });
    //     feature.setId('hunter-' + options.id);
    //     this.getSource().addFeature(feature);
    //
    //     if (options.resize) {
    //         this.fitInView();
    //     }
    // }

    addHuntersPointsFromObject(huntersPoints, options = {}) {

        let zoom = this.map.getView().getZoom();
        if (huntersPoints !== null) {
            for (let point of huntersPoints) {
                let feature = this.addFeature([point.longitude, point.latitude], {
                    resize: options.resize ?? false,
                    fields: {
                        zoomLimit: 13.5,
                        type: 'hunter',
                        point_id: point.id,
                        name: point.name,
                        device_type: point.type,
                        device_id: point.device_id ? point.device_id : null
                    }
                });

                if (zoom < 13.5) {
                    feature.setStyle(farHuntersPointsStyle);
                }

            }
        }

    }
}